import { Box, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FormCheckbox } from 'redesign';
import { FilterEmploymentTypeFormContext } from './filter-employment-type.types';
type EmploymentTypeOptions = 'isFreelance' | 'isTempWork' | 'isEmployee';

export const FilterEmploymentType = ({ hasEmployee }: { hasEmployee?: boolean }) => {
  const { control, watch, clearErrors } = useFormContext<FilterEmploymentTypeFormContext>();
  const { employmentTypeCheckboxValue } = watch();
  const employmentTypes: { name: EmploymentTypeOptions; label: string }[] = [
    { name: 'isFreelance', label: 'Zelfstandige' },
    { name: 'isTempWork', label: 'Uitzendkracht' },
  ];
  if (hasEmployee) {
    employmentTypes.push({ name: 'isEmployee', label: 'Werknemer' });
  }
  return (
    <Box>
      <FormCheckbox
        name="employmentTypeCheckboxValue"
        label="Dienstverband functie"
        control={control}
        isHeaderCheckbox={true}
      />
      {employmentTypeCheckboxValue ? (
        <StyledBox>
          {employmentTypes.map((item) => (
            <FormCheckbox
              label={item.label}
              key={item.name}
              name={item.name}
              onChange={(val) => {
                if (val) {
                  clearErrors('isFreelance');
                }
              }}
              control={control}
            />
          ))}
        </StyledBox>
      ) : null}
    </Box>
  );
};

const StyledBox = styled(Box)(() => ({
  paddingLeft: '10px',
}));
